// jQuery Global Shim
// ===================
// Exposes npm jQuery 3 as window.$ and window.jQuery.
// Sprockets also loads jQuery 3 (//= require jquery3) — same version, no conflict.
// Both pipelines are now unified on a single jQuery version.

import $ from 'jquery';
import 'jquery-migrate'; // Compatibility warnings for deprecated jQuery APIs

// Both Sprockets and npm load jQuery 3.x — globals are identical at runtime
window.$ = window.jQuery = $;

// Export for ES6 module imports
export default $;
